import React from 'react'
import { Image } from 'react-native'

import { useDsaLogo } from '../../hooks/useDsaLogo'

const DsaLogo = () => {
  const { logo } = useDsaLogo()

  if (logo)
    return (
      <Image
        style={{ width: 100, height: 40 }}
        resizeMethod={'auto'}
        resizeMode={'contain'}
        source={{
          uri: logo,
        }}
      />
    )
  return null
}

export default DsaLogo
